import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/contact-orders/components/BulkOrderSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/contact-orders/components/FAQSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/contact-orders/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/contact-orders/components/QuickContactButtons.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/ui/AppIcon.tsx");
